<template>
  <div class="containerMessage" :style="{ 'background-color': 'none' }">
    <ul class="ulMessageMenu">
      <li
        v-for="(item, index) in getObjectMenu(message.message)"
        :key="index"
        v-on:click="sendMessage(item.option, index)"
        v-bind:class="
          optionClicked
            ? 'changeCursor ' +
              (index + 1 !== optionClicked ? 'notselected' : 'selected')
            : 'selected'
        "
        class="liMessageMenu"
        :style="{
          'border-color': getWebchat().campaign.color,
          color: invertColor(getWebchat().campaign.color, true, true),
        }"
      >
        <span style="float: left; position: absolute; top: 6px">
          <v-icon
            :style="{
              color: invertColor(getWebchat().campaign.color, true, true),
            }"
          >
            mdi-chevron-right
          </v-icon>
        </span>

        <div
          v-for="e in item.optionName"
          :key="e.optionName"
          class="pMessageMenu"
          v-bind:class="optionClicked ? 'changeCursor' : ''"
          :style="{
            color: invertColor(getWebchat().campaign.color, true, true),
            'font-size': '14px',
          }"
        >
          <a
            v-bind:class="optionClicked ? 'changeCursor' : ''"
            :style="{
              color: invertColor(getWebchat().campaign.color, true, true),
              'font-size': '14px',
            }"
            v-html="styleMessage(e)"
          ></a>
        </div>
      </li>
    </ul>
  </div>
</template>

<style>
.liMessageMenu {
  margin-bottom: 10px;
  padding: 8px;
  padding-left: 17px;
  border-radius: 50px;
  border: 2px solid #fff;
  background: white;
  min-width: 50px;
  padding: 8px 10px;

  font-weight: 400;
  word-wrap: break-word;
  border-radius: 20px;
  position: relative;
}

.liMessageMenu:hover {
  background: #e1e1e182;
  cursor: pointer;
}

.liMessageMenu a {
  margin-left: 26px;
  display: inline-block;
}
.ulMessageMenu {
  padding-left: 0px;
}
.notselected {
  background: #e1e1e182;
  opacity: 0.3;
}

.selected {
  background: #fff !important;
}

.changeCursor {
  cursor: default !important;
}

.pMessageMenu {
  margin-bottom: 0px !important;
}

.option-number {
  display: inline-block;
  position: absolute;
}
</style>
<script>
import { invertColor } from "@/assets/utils";
import { styleMessage } from "@/assets/utils";

export default {
  props: { message: Object },
  name: "messageMenu",
  components: {},
  computed: {},
  methods: {
    disableMenuMessage(message) {
      this.message.optionClicked = message;
      this.optionClicked = message;
    },
    sendMessage(message, index) {
      if (!this.message.optionClicked) {
        this.message.optionClicked = message;
        this.optionClicked = message;
        this.$eventManagerMenu.sendMessage(message);
        this.$store.commit("updateMessage", this.message);
      }
    },
    getObjectMenu(message) {
      let msg = message.split(/(\d+ *\- *)/g);
      msg = msg.filter((item) => item);
      var arr = [];
      for (var i = 0; i < msg.length; i++) {
        if (msg[i].match(/(\d+ *\- *)/g)) {
          arr.push(msg[i].trim());
        } else {
          let e = arr.pop();
          e = e + msg[i].trim();
          arr.push(e);
        }
      }

      return arr.map((m) => {
        let item = {};
        item.option = parseInt(m.split(/\-/)[0].replace("-", "").trim());
        item.optionName = m.split(/\-/)[1];
        item.optionName = item.optionName.split(String.fromCharCode(10));
        item.optionName = item.optionName.filter((item) => item);

        item.optionName[0] = item.option + " - " + item.optionName[0];
        return item;
      });
    },
    getWebchat() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ];
    },
    invertColor,
    styleMessage,
  },
  created() {
    this.optionClicked = this.message.optionClicked;
  },
  data() {
    return {
      optionClicked: false,
    };
  },
};
</script>
